@if (typeMessage) {
  <span>
    <span class="sr-only">{{ 'listelement.badge.dso-type' | translate }}</span>
    <span class="badge bg-info">{{ typeMessage | translate }}</span>
    <span class="sr-only">, </span>
  </span>
}
